export default {
  getReportData: state => state.reportData,
  getOrderReportData: state => state.orderReportData,
  getOrderDurationReportData: state => state.orderDurationReportData,
  getOrderTimeInStatusReportData: state => state.orderTimeInStatusReportData,
  getOrderTippingReportData: state => state.orderTippingReportData,
  getSalespersons: state => state.salespersons,
  getOrderTippingSummary: state => state.orderTippingSummary,
  getProductReportData: state => state.productReportData,
  getPaymentReportData: state => state.paymentReportData,
  getReportDataByPayment: state => state.reportDataByPayment,
  getColsData: state => state.colsData,
  getJsonFields: state => state.json_fields,
  getJsonData: state => state.json_data,
  getJsonFieldsOrder: state => state.json_fields_order,
  getJsonDataOrder: state => state.json_data_order,
  getQuery: state => state.query,
  getIsChangeStore: state => state.isChangeStore,
  getCountItems: state => state.count_items,
  getSellReport: state => state.sellReportData,
  getJsonFieldsSellReport: state => state.json_fields_sell_report,
  getJsonDataSellReport: state => state.json_data_sell_report,
  getGlobalReport: state => state.globalReport,
  getIsExporting: state => state.isExporting,
  getLoadingProductSoldChart: state => state.isLoadingProductSoldChart,
  getProductSoldChart: state => state.productSoldChart,
  getCustomizeFields: state => state.customizeFields,
  getSalesOrderData: state => state.salesOrderData,
  getDailyReportData: state => state.dailyReportData,
  getMonthlyReportData: state => state.monthlyReportData,
  geDailyTaxReportData: state => state.dailyTaxReportData
}
